
import {
    TIME_LINE_DETAIL,TIME_LINE_DETAIL_SUCCESS,TIME_LINE_DETAIL_FAILED,SEND_REMINDER,SEND_REMINDER_SUCCESS,SEND_REMINDER_FAILED
  } from "./actionTypes";
  const initialState = {
    loader: false,
    timeLineData:null,
timeLineError:null,
sendReminderData:null,
sendReminderError:null,
    
  };
  
  const timeLineReducer = (state = initialState, action) => {
    switch (action.type) {
        case TIME_LINE_DETAIL:
        state = {
                                ...state,
                                loader: true,
                                timeLineData:null,
                                timeLineError:null
                }
        break  
         case TIME_LINE_DETAIL_SUCCESS:
         state = {
                                   ...state,
                                   loader: false,
                                   timeLineData:action.payload,
                                   timeLineError:null
         }
         break     
         case TIME_LINE_DETAIL_FAILED:
        state = {
                                       ...state,
                                       loader: false,
                                       timeLineData:null,
                                       timeLineError:action.payload,
        }
        break       
        case SEND_REMINDER:
       state = {
                               ...state,
                               loader: true,
                               sendReminderData:null,
                               sendReminderError:null
               }
       break  
        case SEND_REMINDER_SUCCESS:
        state = {
                                  ...state,
                                  loader: false,
                                  sendReminderData:action.payload,
                                  sendReminderError:null
        }
        break     
        case SEND_REMINDER_FAILED:
       state = {
                                      ...state,
                                      loader: false,
                                      sendReminderData:null,
                                      sendReminderError:action.payload,
       }
       break 
        
                       
      default:
        state = { ...state };
        break;
    }
    return state;
  };
  export default timeLineReducer;
  